import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/seance-actions';
import { SeanceActions } from '../constants';
import { ISeance, ISeanceStatistics } from 'src/types/seance';

export interface SeanceState {
    inProgress: boolean;
    inProgressCSV: boolean;
    authCode: string;
    error: string;
    data: Paginated<ISeance>;
    unconfirmed: any[];
    current: ISeance | null;
    miniLoaderFor: { [key: string]: boolean };
    statistics: ISeanceStatistics | null;
    currentFiles: any | null;
    copySeance: ISeance | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    statistics: null,
    inProgressCSV: false,
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    },
    unconfirmed: [],
    miniLoaderFor: {},
    current: null,
    currentFiles: null,
    copySeance: null,
};

export function seances(state: SeanceState = initialState, action: Actions | any): SeanceState {
    switch (action.type) {
        case requestType(SeanceActions.PERSIST_SEANCE):
            return { ...state, error: '', inProgress: true };

        case requestType(SeanceActions.FETCH_MULTI_SEANCE):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    page: 1,
                    meta: state.data?.meta,
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(SeanceActions.PERSIST_SEANCE):
            if (action.payload.editMode) {
                state.data.list.forEach((it: any, k: number) => {
                    if (+it.id === +action.payload.id) {
                        state.data.list[k] = action.payload;
                    }
                });
            }
            return { ...state, current: action.payload, inProgress: false };
        case failureType(SeanceActions.PERSIST_SEANCE):
            return { ...state, error: action.error, inProgress: false };
        case requestType(SeanceActions.FETCH_SEANCES):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    page: 1,
                    totalPages: undefined,
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(SeanceActions.FETCH_SEANCES):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(SeanceActions.FETCH_SEANCES):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };
        case requestType(SeanceActions.SIGN_SEANCE):
            return { ...state, error: '', inProgress: true };
        case failureType(SeanceActions.SIGN_SEANCE):
            return { ...state, error: '', inProgress: false };
        case requestType(SeanceActions.FETCH_SEANCES_CSV):
            return {
                ...state,
                inProgressCSV: true,
            };
        case successType(SeanceActions.FETCH_SEANCES_CSV):
            return {
                ...state,
                inProgressCSV: false,
            };
        case failureType(SeanceActions.FETCH_SEANCES_CSV):
            return {
                ...state,
                inProgressCSV: false,
            };
        case requestType(SeanceActions.FETCH_UNCONFIRMED_SEANCES):
            return {
                ...state,
                unconfirmed: [],
                error: '',
                inProgress: true,
            };
        case successType(SeanceActions.FETCH_UNCONFIRMED_SEANCES):
            return {
                ...state,
                unconfirmed: action.payload,
                inProgress: false,
            };
        case failureType(SeanceActions.FETCH_UNCONFIRMED_SEANCES):
            return {
                ...state,
                unconfirmed: state.unconfirmed,
                error: action.error,
                inProgress: false,
            };

        case requestType(SeanceActions.FETCH_SEANCE_STATISTICS):
            return { ...state, error: '', inProgress: true };
        case successType(SeanceActions.FETCH_SEANCE_STATISTICS):
            return { ...state, statistics: action.payload, inProgress: false };
        case failureType(SeanceActions.FETCH_SEANCE_STATISTICS):
            return { ...state, error: action.error, inProgress: false };
        case requestType(SeanceActions.FETCH_SEANCE):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(SeanceActions.FETCH_SEANCE):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(SeanceActions.FETCH_SEANCE):
            return { ...state, inProgress: false, error: action.error };
        case requestType(SeanceActions.COPY_NOTE_SEANCE):
            return { ...state, inProgress: true, copySeance: null, error: '' };
        case successType(SeanceActions.COPY_NOTE_SEANCE):
            return { ...state, inProgress: false, copySeance: action.payload };
        case failureType(SeanceActions.COPY_NOTE_SEANCE):
            return { ...state, inProgress: false, error: action.error };
        case requestType(SeanceActions.DELETE_SEANCE):
            return { ...state, error: '', inProgress: true };
        case successType(SeanceActions.DELETE_SEANCE):
            const list = state.data.list.map((seance: ISeance) => {
                if (`${action.sagaPayload?.id}` === `${seance.id}`) {
                    seance.status = 5;
                }
                return seance;
            });
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: list,
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case requestType(SeanceActions.UPDATE_SEANCE):
            return { ...state, error: '', inProgress: true };
        case successType(SeanceActions.UPDATE_SEANCE):
            state.data.list.forEach((seance: ISeance, k, array) => {
                if (seance.id === action.payload.id) {
                    array[k] = { ...array[k], ...action.payload };
                }
            });
            return {
                ...state,
                data: {
                    ...state.data,
                    list: state.data.list,
                    meta: state.data.meta,
                },
                inProgress: false,
            };
        case failureType(SeanceActions.UPDATE_SEANCE):
            return {
                ...state,
                error: action.error?.response?.data?.errorMessage ?? 'Unknown error',
                miniLoaderFor: {},
                inProgress: false,
            };
        case failureType(SeanceActions.DELETE_SEANCE):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        case requestType(SeanceActions.FETCH_FILES_SEANCE):
            return { ...state, error: '', miniLoaderFor: { FILE: true } };
        case successType(SeanceActions.FETCH_FILES_SEANCE):
            return { ...state, miniLoaderFor: {}, currentFiles: action.payload };
        case failureType(SeanceActions.FETCH_FILES_SEANCE):
            return { ...state, miniLoaderFor: {}, error: action.error };
        case requestType(SeanceActions.DELETE_FILE_SEANCE):
            return { ...state, error: '', miniLoaderFor: { FILE: true } };
        case successType(SeanceActions.DELETE_FILE_SEANCE):
            const { sagaPayload } = action;
            const curNewFiles = (state.currentFiles ?? []).filter((file: any) => file.id !== sagaPayload.id);

            return {
                ...state,
                miniLoaderFor: {},
                currentFiles: curNewFiles,
            };
        case failureType(SeanceActions.DELETE_FILE_SEANCE):
            return { ...state, miniLoaderFor: {}, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        case requestType(SeanceActions.CREATE_FILES_SEANCE):
            return { ...state, error: '', miniLoaderFor: { FILE: true } };
        case successType(SeanceActions.CREATE_FILES_SEANCE):
            const curFiles = [...(state.currentFiles ?? [])];
            curFiles.push(action.payload);

            return {
                ...state,
                miniLoaderFor: {},
                currentFiles: curFiles,
            };
        case failureType(SeanceActions.CREATE_FILES_SEANCE):
            return { ...state, miniLoaderFor: {}, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        default:
            return state;
    }
}
